import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import ServicesLanding from "../views/ServicesLanding";

export default function Services() {
  const appContext = useContext(AppContext);
  const [view, setView] = useState(null);

  async function init() {
    // run initializations here
  }

  function getView() {
    if (!appContext.navSubItem && !appContext.navExtraItem && !appContext.navMoreItem) {
      return <ServicesLanding />;
    }

    return <ServicesLanding />;
  }

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    const nextView = getView();
    if (nextView) {
      setView(nextView);
    }
  }, [appContext.navSubItem, appContext.navExtraItem, appContext.navMoreItem]);

  return view;
}
